import { IHttpApi } from '@cian/http-api';
import { ILogger } from '@cian/logger';

import { EResult } from '../../repositories/files/entities/Models/AddFileResponse';
import { fetchAdd, TAddResponse } from '../../repositories/files/v1/add';
import { EExceptionDomain } from '../../types/exceptionDomains';
import { ICancellationToken } from '../../utils/cancelationToken';
import { getGenericLikeError } from '../../utils/logging/getGenericLikeError';

interface IAddFilesContext {
  httpApi: IHttpApi;
  logger: ILogger;
}

interface IAddFilesRequest {
  file?: File;
  cancellationToken: ICancellationToken;
}

export { EResult as EAddFilesResult };

export async function addFiles(context: IAddFilesContext, { file, cancellationToken }: IAddFilesRequest) {
  const { httpApi, logger } = context;

  try {
    const response: TAddResponse = await fetchAdd({
      httpApi,
      parameters: {
        file,
      },
      config: {
        cancellationToken,
      },
    });

    return { response: response.response, responseStatusCode: response.statusCode };
  } catch (error) {
    const exception = getGenericLikeError({
      error,
      domain: EExceptionDomain.Messages,
      message: 'Не удалось загрузить файл на сервер',
    });

    logger.warning(exception, {
      microserviceName: 'files',
      pathApi: '/v1/add/',
    });

    throw exception;
  }
}
